<template>
    <div
        class="cursor-pointer ring-1 ring-inset ct-bg-1--alt rounded-lg p-3 flex items-center space-x-2 shadow-sm shadow-gray-900/5"
        :class="[isSelected ? 'ct-ring-brand' : 'ct-ring-1 hover:ct-ring-brand cursor-pointer']"
    >
        <CardHoverLink
            :src="item.photo_url"
            :link="item.full_url"
            :icon="productIcon"
            class="flex-shrink-0"
        />
        <div class="flex-grow text-sm overflow-hidden">
            <p class="font-medium ct-text-1 truncate">{{ item.name }}</p>
            <p class="ct-text-3 truncate">{{ item.description }}</p>
        </div>
    </div>
</template>

<script>
import { ShippingBoxIcon } from "@easy/ui/icons";
import { CardHoverLink } from "@easy/ui/cards";

export default {
    components: {
        CardHoverLink,
    },
    name: "ProductCard",
    props: {
        item: Object,
        isSelected: Boolean,
    },
    computed: {
        productIcon() {
            return ShippingBoxIcon;
        },
    },
};
</script>
